module.exports = __webpack_public_path__ + "static/media/12.283180e9.png";